module.exports = __webpack_public_path__ + "static/media/start_over.b744c07e.svg";